"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.shareWxMiniprogram = void 0;
var constant_1 = require("./constant");
/**
 * 分享小程序
 * @param { ShareOptions } options 分享参数
 */
function shareWxMiniprogram(options) {
    return new Promise(function (resolve, reject) {
        try {
            // 获取分享服务列表
            window.plus.share.getServices(function (s) {
                // 获取微信分享服务
                var shareService = s.find(function (item) { return item.id === 'weixin'; });
                // 判断是否支持微信分享
                if (!shareService) {
                    reject(new Error('当前环境不支持微信分享操作'));
                    return;
                }
                var title = options.title, content = options.content, thumbs = options.thumbs, appId = options.appId, appPath = options.appPath, webUrl = options.webUrl, envVersion = options.envVersion;
                // 分享消息 - 微信小程序卡片
                var shareMsg = {
                    type: 'miniProgram',
                    title: title,
                    content: content,
                    thumbs: thumbs,
                    miniProgram: {
                        id: appId,
                        path: appPath,
                        type: constant_1.EnvVersion[envVersion],
                        webUrl: webUrl
                    }
                };
                // 判断是否已经授权
                if (shareService.authenticated) {
                    shareService.send(shareMsg, function () {
                        resolve();
                    }, function (e) {
                        console.error("\u5206\u4EAB\u5931\u8D25\uFF1A".concat(JSON.stringify(e)));
                        reject(e);
                    });
                }
                else {
                    // 未授权则先授权
                    shareService.authorize(function () {
                        shareService.send(shareMsg, function () {
                            resolve();
                        }, function (e) {
                            console.error("\u5206\u4EAB\u5931\u8D25\uFF1A".concat(JSON.stringify(e)));
                            reject(e);
                        });
                    }, function (e) {
                        console.error("\u83B7\u53D6\u5206\u4EAB\u670D\u52A1\u5217\u8868\u5931\u8D25\uFF1A".concat(JSON.stringify(e)));
                        reject(e);
                    });
                }
            }, function (e) {
                console.error("\u83B7\u53D6\u5206\u4EAB\u670D\u52A1\u5217\u8868\u5931\u8D25\uFF1A".concat(JSON.stringify(e)));
                reject(e);
            });
        }
        catch (error) {
            reject(error);
        }
    });
}
exports.shareWxMiniprogram = shareWxMiniprogram;
//# sourceMappingURL=share.js.map